import React, { useMemo } from 'react';
import loader from '../images/loader-transparent.gif';

function getSize({ width, height, size }) {
  if (width && !height) {
    return { width, height: width }
  }
  if (width && height) {
    return { width, height }
  }
  switch(size) {
    case 'xl':
      return { width: 80, height: 80 }
    case 'lg':
        return { width: 50, height: 50 }
    case 'md':
        return { width: 40, height: 40 }
    case 'sm':
        return { width: 30, height: 30 }
    case 'xs':
        return { width: 15, height: 15 }
  }
}

export function TratoLoader({ className, width, height, size = 'md' }) {
  const { width: internalWidth, height: internalHeight } = useMemo(() => 
    getSize({width, height, size}), 
    [width, height, size]
  )
  
  return (
    <img 
      className={className} 
      src={loader}
      alt="loading" 
      style={{
        width:internalWidth, 
        height: internalHeight
      }} 
    />
  )
}

export default TratoLoader
